import React, { useEffect } from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useSidebar } from '../controllers/use-sidebar/index.tsx';

export const SidebarLayout = ({ children }: { children: React.ReactNode }) => {
	const [{ content }, { closeSidebar }] = useSidebar();

	// reset sidebar content on view unmount
	useEffect(
		() => () => {
			closeSidebar();
		},
		[closeSidebar],
	);

	return (
		<Flex testId="platform-sidebar.ui.sidebar-layout" xcss={wrapperStyles} direction="row">
			<Box xcss={[childContainerStyles]}>{children}</Box>
			{content ? <Box xcss={[sidebarStyles]}>{content}</Box> : null}
		</Flex>
	);
};

const wrapperStyles = xcss({
	height: '100%',
	overflowY: 'auto',
});

const childContainerStyles = xcss({
	flexGrow: 1,
	flexShrink: 1,
	flexBasis: 0,
	overflowY: 'auto',
});

const sidebarStyles = xcss({
	backgroundColor: 'elevation.surface',
	boxShadow: 'elevation.shadow.overlay',
	// FIX ME - remove hardcoded width, implement responsive sidebar
	width: '350px',
});
